import * as React from "react";
import * as H from "history";
import { RouteComponentProps } from "react-router-dom";
import { toast } from "react-toastify";
import { SmartApplyApiError } from "./../../apis/api-error";

export abstract class BaseApplicationService<State> {
  state!: State;

  private innerHistory!: H.History;
  private uiStateMutator!: (s: Partial<State>) => void;

  setHistory(history: H.History) {
    this.innerHistory = history;
  }

  setUIStateMutator(m: (s: Partial<State>) => void) {
    this.uiStateMutator = m;
  }

  protected setState(
    updater: Partial<State> | ((prevState: State) => Partial<State>),
  ) {
    let nextState;
    if (typeof updater === "function") {
      nextState = updater(this.state);
    } else {
      nextState = updater;
    }

    this.state = Object.assign({}, this.state, nextState);
    this.uiStateMutator(nextState);
  }

  protected handleRetryableError(e: Error) {
    if (SmartApplyApiError.isRetryable(e)) {
      toast.error(
        "ネットワークエラーが発生しました。リトライをお試しください。",
      );
      return true;
    }
    return false;
  }

  protected get history() {
    return this.innerHistory;
  }
}

export function connectService<
  P,
  T extends P,
  SERVICE extends BaseApplicationService<T>,
>(
  WrappedComponent: React.ComponentType<P & T>,
  serviceFactory: (p: P) => SERVICE,
) {
  class Wrapper extends React.PureComponent<P, T> {
    service: SERVICE;

    constructor(props: P) {
      super(props);
      this.service = serviceFactory(props);
      // 型を繋げられなかったためanyに落とす
      this.service.setUIStateMutator(this.setState.bind(this) as any);
      this.state = this.service.state;
    }

    render() {
      return <WrappedComponent {...this.state} />;
    }
  }
  return Wrapper;
}

export function connectPageService<
  T,
  SERVICE extends BaseApplicationService<T>,
>(WrappedComponent: React.ComponentType<T>, serviceFactory: () => SERVICE) {
  class Wrapper extends React.PureComponent<RouteComponentProps, T> {
    service: SERVICE;

    constructor(props: RouteComponentProps) {
      super(props);
      this.service = serviceFactory();
      this.service.setHistory(this.props.history);
      // 型を繋げられなかったためanyに落とす
      this.service.setUIStateMutator(this.setState.bind(this) as any);
      this.state = this.service.state;
    }

    render() {
      return <WrappedComponent {...this.state} />;
    }
  }
  return Wrapper;
}
